import React, {
  useState,
  createContext,
  useContext,
  useEffect,
  useMemo,
} from "react";
import { isAuthenticated } from "./storage";
import { onAuthChange } from "./events";

export const AuthContext = createContext({ isAuthenticated: false });

export function AuthContextProvider({ children }: { children: React.ReactNode }) {
  const [isAuthenticatedValue, setIsAuthenticatedValue] = useState(() =>
    isAuthenticated()
  );

  useEffect(() => {
    setIsAuthenticatedValue(isAuthenticated());
    const unsubscribe = onAuthChange((currentIsAuthenticatedValue) => {
      setIsAuthenticatedValue(currentIsAuthenticatedValue);
    });
    return unsubscribe;
  }, []);

  const contextValue = useMemo(() => {
    return { isAuthenticated: isAuthenticatedValue };
  }, [isAuthenticatedValue]);

  return (
    <AuthContext.Provider value={contextValue}>{children}</AuthContext.Provider>
  );
}

export function useIsAuthenticated() {
  const { isAuthenticated } = useContext(AuthContext);
  return isAuthenticated;
}
